export default __webpack_public_path__ + "static/media/smiley-03.d5105df0.png";